
import Logo from '../assets/logo.png'
import mail from '../assets/mail.png'
import phone from '../assets/phone.png'
import clock from '../assets/clock.png'
import location from '../assets/location.png'
import { useNavigate } from 'react-router-dom'


export const Footer = () => {

    const navigate = useNavigate();

    const navLinks = {
        quickLinksOne: [
            { label: "About Us", path: "/about" },
            // { label: "Capabilities", path: "/capable" },
            { label: "Products", path: "/product" },
            // { label: "Work with us", path: "/about" },

        ],
        quickLinksTwo: [
            { label: "CareerConnect Ai", path: '/product/ccai' },
            { label: "CareerConnect ATS", path: '/product/ccai-ats' },
            { label: "SAN HRMS", path: '/product/hrms' },
            { label: "SAN LMS *", path: '/product/lms' },
        ],


    }

    let oueServices = [
        {
            name: 'Engineering & Platforms',
            content: ["Web Development", "Mobile Application Development", "Mobile Application Development", "Enterprise Systems"]

        },
        {
            name: 'Intelligence & Automation',
            content: ['AI & Machine Learning', 'Intelligent Automation', 'Data & Analytics', 'Business Intelligence Systems']
        },
        {
            name: 'Design & Experience',
            content: ['UI / UX Design', 'Design Strategy', 'Brand Systems', 'Digital Experience Design']
        },
        {
            name: 'Growth & Visibility',
            content: ['Digital Marketing', 'Performance Marketing', 'Search Engine Optimization (SEO)', 'Growth Analytics']
        },
        {
            name: 'Connected Systems',
            content: ['IoT Solutions', 'Hardware Integration', 'Monitoring & Control Systems', 'Smart Device Platforms']
        },

    ]

    return (
        <footer className="  px-6 md:px-16 lg:px-24 my-3">
            <div className='px-2 mx-auto max-w-7xl'>
                <div className='flex flex-wrap sm:flex-row  sm:justify-between   mt-8  mb-0 items-stretch'>

                    <div className='w-[316px]'>

                        <img
                            src={Logo}
                            alt="logo"
                            className="h-[110px] w-[190px] md:w-[200px] md:h-[114px]"
                            onClick={() => navigate('/')}
                        />
                        <p className='leading-7 font-secondary text-[18px] '>Engineering tomorrow's technology with precision and intelligent design.</p>
                    </div>

                    <div className='mr-10 sm:mr-0'>
                        <h3 className='sm:text-[24px] text-[17px] font-semibold   my-4 sm:my-0 tracking-[0.2px]'>Company</h3>
                        <ul className=" space-y-3 sm:space-y-5  sm:my-5 ">
                            {
                                navLinks.quickLinksOne.map((links, i) =>
                                (
                                    <li key={i}>
                                        <button
                                            type='button'
                                            onClick={() => {
                                                if (links.path && links.path !== "#") {
                                                    navigate(links.path);
                                                }
                                            }}
                                            className="font-secondary text-black  transition-colors text-[14px] sm:text-[18px]"
                                        >
                                            {links.label}
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>

                    <div>
                        <h3 className='sm:text-[24px] text-[17px] font-semibold  my-4 sm:my-0 tracking-[0.2px]'>Products</h3>

                        <ul className="space-y-3 sm:space-y-5  sm:my-5">
                            {navLinks.quickLinksTwo.map((links, i) => (
                                <li key={i}>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (links.path === "#") {
                                                links.onClick?.();
                                            } else {
                                                navigate(links.path);
                                            }
                                        }}
                                        className="font-secondary text-black  transition-colors text-[14px] sm:text-[18px]"
                                    >
                                        <span>{links.label}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>



                    <div>
                        <h3 className='font-semibold mx-0 lg:mx-20 my-4 sm:my-0 sm:text-[24px] text-[17px] tracking-[0.2px]'>Contact </h3>

                        <div className=' sm:my-5 '>
                            <div className='flex justify-start items-center gap-2  my-5 cursor-pointer'>
                                <img src={phone} className='h-5 w-5' alt='phone' />
                                <p className='text-black text-[14px] sm:text-[18px] font-secondary ' onClick={() => window.open('https://wa.me/7418169679')}>+91 74181 69679 | +91 95001 73908</p>
                            </div>

                            <div className='flex justify-start items-center gap-2 my-5 cursor-pointer'>
                                <img src={mail} className='h-5 w-5' alt='mail' />
                                <p className='text-black text-[14px] sm:text-[18px] font-secondary'
                                    onClick={() => window.open('mailto:info@santechnovation.com', '_blank')}>info@santechnovation.com</p>
                            </div>

                            <div className='flex justify-start items-center gap-2  my-5'>
                                <img src={clock} className='h-5 w-5' alt='clock' />
                                <p className='text-black text-[14px] sm:text-[18px] font-secondary'>9:30 AM – 6:30 PM (Monday – Saturday)</p>
                            </div>

                            <div className='flex gap-5'>
                                <div className='flex justify-start items-center gap-2  cursor-pointer'>
                                    <img src={location} className='h-5 w-5' alt='location' />
                                    <p className='text-black text-[14px] sm:text-[18px]  md:w-[370px] font-secondary' >2nd Floor, VSM Complex, Near Anna Statue, Kanjikovil Road, Perundurai, Erode – 638052 </p>
                                </div>


                            </div>
                        </div>
                    </div>


                </div>
                <div className="mr-10 sm:mr-0 mb-7">
                    <h3 className="text-[17px] sm:text-[24px] font-semibold my-4 tracking-[0.2px] cursor-pointer"
                        onClick={() => navigate('/capable')}>
                        Our Services
                    </h3>

                    <div className=" grid grid-cols-1 gap-4 sm:flex sm:gap-14 mt-2">
                        {oueServices.map((links, i) => (
                            <div key={i}>
                                <h5 className="font-semibold text-[14px] sm:text-[17px] mb-4 cursor-pointer "

                                    onClick={() => {
                                        window.location.href = `/services?id=${Date.now()}#${links.name}`;
                                    }
                                    }
                                >
                                    {links.name}
                                </h5>

                                {links.content.map(con => (
                                    <ul className="mb-3 sm:mb-5">
                                        <li>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    window.location.href = `/services?title=${con}#${links.name}`;
                                                }}
                                                className="text-[12px] sm:text-[14px] text-black hover:text-primary-600 transition-colors text-left font-primary"
                                            >
                                                {con}
                                            </button>
                                        </li>
                                    </ul>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className=' h-[1px] bg-[#d1d1d1]   max-w-7xl'> </div>


                <div className=' block sm:flex justify-between gap-3 my-5 sm:my-0'>
                    <p className='text-[#6b6a6a] text-[10px] sm:text-[14px] sm:my-5 '>© 2026 SAN Technovation Pvt Ltd. All rights reserved.</p>
                    <div className='flex gap-2'>
                        <p className='text-[#6b6a6a] text-[10px] sm:text-[14px] my-5 '>Privacy Policy |</p>
                        <p className='text-[#6b6a6a] text-[10px] sm:text-[14px] my-5 '>Terms of Service |</p>

                        {/* <p className='text-[#6b6a6a] text-[10px] sm:text-[14px] my-5 '>Cookie Policy</p> */}


                    </div>

                </div>

            </div>
            {/* {open === "privacy" && (
                <PrivacyPolicyModal isOpen={open} onClose={() => setOpen("")} />
            )}

            {open === "terms" && (
                <TermsCondition isOpen={open} onClose={() => setOpen("")} />
            )} */}
        </footer>
    )
}

